module.exports = __webpack_public_path__ + "img/9788949120751.c21da7a4.jpg";